import { isAppHostRequest } from "@/utils/hosts";
import axios from "axios";

const READ_ONLY_METHODS = ["get", "head", "options"];

let csrfCookieRequest: Promise<unknown> | null = null;

function hasCsrfCookie(): boolean {
    return document.cookie
        .split("; ")
        .some((cookie) => cookie.startsWith("XSRF-TOKEN="));
}

function fetchCsrfCookie(): Promise<unknown> {
    csrfCookieRequest ??= axios
        .get(route("sanctum.csrf-cookie"))
        .finally(() => {
            csrfCookieRequest = null;
        });

    return csrfCookieRequest;
}

/*
 * The SPA calls the API cross-origin, so the session cookie and the CSRF header
 * have to be requested explicitly. Only calls to our own app host get them:
 * third-party clients built on axios, such as Stream Chat, inherit axios
 * defaults and their APIs reject the extra header.
 *
 * Laravel hands out the CSRF cookie with its responses, and a visitor who has
 * only seen logged out pages may not have had one yet, so the first write asks
 * for it before it goes out.
 */
axios.interceptors.request.use(async (config) => {
    if (!isAppHostRequest(config.url)) {
        return config;
    }

    config.withCredentials = true;
    config.withXSRFToken = true;

    const isWrite = !READ_ONLY_METHODS.includes(config.method ?? "get");
    if (isWrite && !hasCsrfCookie()) {
        await fetchCsrfCookie();
    }

    return config;
});
